export enum RecipeServingType {
  Servings = 0,
  Weight = 1,
}